import React, { useEffect, useRef, useState } from "react";
import { Alert } from "react-bootstrap";
import { Trans } from "react-i18next";
import { useAppSelector } from "../redux/hooks";
import { UserState } from "../redux/reducers/UserSlice";
import "../styles/components/SuccessMessage.scss";

const SuccessMessage = (props: any) => {
  const [showAlert, setShowAlert] = useState(true);
  const userDetails: any = useAppSelector(UserState);
  const scrollRef = useRef<HTMLDivElement>(null);
  const scrollToAlert = () => {
    if (scrollRef.current) {
      window.scrollTo({ top: scrollRef.current.offsetTop, behavior: "auto" });
    }
  };

  useEffect(() => {
    scrollToAlert();
  }, []);

  return (
    <>
      {showAlert ? (
        <div
          className={`
            ${
              userDetails?.userDetails?.app_metadata?.organizations?.EODB?.groups[0]?.includes(
                "Admin"
              )
                ? "successMessage successMessageAdmin"
                : "successMessage"
            } ${
            props.page === "viewProfile"
              ? "successMessageViewProfile"
              : props.page === "ashaDetails"
              ? "successMessageAshaDetails"
              : ""
          }`}
        >
          <Alert variant="success">
            <div className="message" ref={scrollRef}>
              <img alt="tick" src="/icons/tick_with_fill.svg" />
              <p className="d-inline-block ps-3 text ml-5">
                <b>
                  {props.patientAdded
                    ? props.patientAdded
                    : props.patientProfile
                    ? props.patientProfile
                    : props.stateAdminActivateDectivate
                    ? props.stateAdminActivateDectivate
                    : props.ashaActivateDectivate
                    ? props.ashaActivateDectivate
                    : null}
                </b>{" "}
                {props.patientAdded ? (
                  <Trans i18nKey={"added_successfully"}></Trans>
                ) : props.patientProfile ? (
                  <Trans i18nKey={"updated_successfully"}></Trans>
                ) : props.stateAdminActivateDectivate ? (
                  <Trans i18nKey={"has_been_successfully"}></Trans>
                ) : props.ashaActivateDectivate ? (
                  <Trans i18nKey={"has_been_successfully"}></Trans>
                ) : null}{" "}
                <Trans i18nKey={props.statusVal}></Trans>
              </p>
            </div>
            <img
              className="closeBtn"
              src="/icons/close.svg"
              onClick={() => {
                setShowAlert(false);
                if (props?.onIconClose) {
                  props.onIconClose();
                }
              }}
            ></img>{" "}
          </Alert>
        </div>
      ) : null}
    </>
  );
};

export default SuccessMessage;
